<script setup lang="ts">
interface Props {
  name: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  class: "",
});
</script>

<template>
  <svg class="inline-block" :class="props.class" aria-hidden="true">
    <use :href="`/static/icons/sprite.svg#${name}`"></use>
  </svg>
</template>
